import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const LoginService = async (body) => {
  const result = await HttpServices.post(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/user/login`,
    body,
    {
      headers: {
        isPublic: true,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const VerifyUserOnBehalf = async (body) => {
  const result = await HttpServices.post(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/user/verification`,
    body,
    {
      headers: {
        isPublic: true,
      },
    },
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const TokenRefreshService = async () => {
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/user/refresh-token`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const LogoutService = async () => {
  const result = await HttpServices.post(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/user/logout`,
    null,
    {
      headers: {
        guard: "employee",
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const ResetPassword = async (body) => {
  const result = await HttpServices.post(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/user/reset-password`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const ValidateSSOKey = async (key) => {
  const result = await HttpServices.post(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/user/sso/validate`,
    {key},
    {
      headers: {
        isPublic: true,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetUserDetails = async () => {
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/recruiter/${process.env.REACT_APP_VERSION_API}/details`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GenerateSSOKey = async () => {
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/user/sso/generate`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
// is_portal 0 for self-service, 1 for recruiter by default from backend is 1
export const ValidateAccountNumber = async ({
  account_number,
  is_portal = 0,
}) => {
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/account/info`,
    {
      params: {
        account_number,
        is_portal,
      },
    },
    {
      headers: {
        isPublic: true,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
export const ValidateThirdPartyToken = async ({
  code,
  provider,
  session_state,
  queryState,
}) => {
  const result = await HttpServices.post(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/account/verified`,
    {
      code,
      provider,
      state: queryState,
      session_state,
    },
    {
      headers: {
        isPublic: true,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
export const GenerateCandidateSSOKey = async ({
  job_uuid,
  clone_company_uuid,
}) => {
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/candidate/${process.env.REACT_APP_VERSION_API_V2}/sso/generate`,
    {
      params: {
        job_uuid,
        clone_company_uuid,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
export const ValidateAccountDomain = async ({
  domain,
  account_uuid,
  is_portal = 0,
}) => {
  const result = await HttpServices.get(
    `${process.env.REACT_APP_INTEGRATIONS_API}/integrations/sso-providers/`,
    {
      params: {
        domain,
        account_uuid,
        is_portal,
      },
      headers: {
        isPublic: true,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
export const ValidateMicroSoftToken = async ({
  code,
  provider,
  session_state,
  queryState,
}) => {
  const result = await HttpServices.post(
    `${process.env.REACT_APP_INTEGRATIONS_API}/integrations/azure/login`,
    {
      code,
      provider,
      state: queryState,
      session_state,
    },
    {
      headers: {
        isPublic: true,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
